import React from "react";
import { Upload, message } from "antd";
import DragIcon from "../../../assets/icons/ic_drag.svg";

import "./stylesCustomDragAndDrop.css";

const { Dragger } = Upload;

const CustomDragAndDrop = ({ onFileUpload, onRemove }) => {
  const props = {
    name: "file",
    multiple: false,
    beforeUpload: (file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        onFileUpload(reader.result); 
      };
      return false; 
    },
    onRemove() {
      onRemove();
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  return (
    <div className="drag-and-drop-container">
      <Dragger {...props}>
        <img src={DragIcon} alt="drag and drop icon" className="ant-upload-drag-icon" />
        <p className="ant-upload-text">Drag and drop to upload icon</p>
        <p className="ant-upload-hint">
          Upload icon size min 64x64px and max 120x120px. Support SVG, EPS
        </p>
        <button className="browse-file">Browse File</button>
      </Dragger>
    </div>
  );
};

export default CustomDragAndDrop;
